<template>
   
  <div class="cxfy_2_001">
     <div class="top-content">
        <top-user-v2 :current-model-name="currentModelName"></top-user-v2>
    </div>
    <div class="search-box">
        <div class="left">
            <div class="top-content base-content" >
                <div class="item">
                    <div class="label" >房屋地址:</div>
                    <div class="value">
                        <Input clearable  @on-change="init"  v-model="params.fwdz" placeholder="请输入..." style="width: 300px"  />
                    </div>
                </div>
            
                  <div class="item">
                    <div class="label" >维修状态:</div>
                    <div class="value"> 
                        <Select v-model="params.wxzt" placeholder="请选择..." clearable @on-change="init">
                        <Option v-for="item in ['待维修','部分维修','已完成']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                    </div>
                </div>
                <div class="item">
                    <div class="label" >维修人:</div>
                    <div class="value">
                        <Input clearable  @on-change="init" v-model="params.wxr" placeholder="请输入..." style="width: 300px" />
                    </div>
                </div> 
                  <div class="item">
                    <div class="label" >报修时间:</div>
                    <div class="value">
                         <DatePicker  format="yyyy-MM-dd" v-model="params.cjsj" type="daterange" placement="bottom-end" placeholder="请选择时间范围" style="width: 300px" @on-change="changeCjsjDate" />
                    </div>
                </div> 
            </div>
             <div class="top-content base-content" >
                 <div class="item">
                    <div class="label" >维修单类型:</div>
                    <div class="value"> 
                        <Select v-model="params.repairType" placeholder="请选择..." clearable @on-change="init" style="width:220px;">
                        <Option v-for="item in ['维修','维保']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                    </div>
                </div>
                 <div class="item">
                    <div class="label" >维保单类型:</div>
                    <div class="value"> 
                        <Select v-model="params.maintenanceType" placeholder="请选择..." clearable @on-change="init" :disabled="params.repairType!='维保'" style="width:220px;">
                        <Option v-for="item in ['到期','违约','换房','续租']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                    </div>
                </div>
                 <div class="item"></div>
                  <div class="item" style="justify-content: flex-end;">
                     <Button type="primary"   icon="ios-search"    @click="init" class="btn">查询</Button>  
                </div>
               
             </div>
              
       

        </div>
        <div class="right"> 
             <Button type="success"   icon="ios-add-circle-outline"    @click="add" class="btn">新增维修单</Button>   
             <Button type="success" ghost  icon="ios-construct-outline"    @click="addMaintenance" class="btn">新增维保单</Button>   
          
           
           
        </div> 
    </div> 
    <!-- <div class="operate-box"> 
   
     
    </div> -->
   
    <div class="data-box">
         <Table border :columns="columns" :data="dataList" class="table-class" :width="screenWidth*0.95" :height="screenHeight*0.7" @on-selection-change="tableChange">
            <template #action="{ row, index } " >
                <div class="buttomGroup">
                    <!-- <div class="btn ck" @click="watchDetail(row)">查看</div> -->
                    <div class="btn tj" @click="watchDetail(row)">查看</div>
                
                    <div class="btn tg" @click="updateDetail(row)">编辑</div> 
                    <div class="btn sc" @click="deleteRecord(row)" >删除</div>  
                </div>
            </template>
         </Table>
        <div class="page-line">
            <Page :total="pageSetting.total" :page-size="pageSetting.pageSize" @on-page-size-change="pageSizeChange"
            @on-change="pageChange" show-elevator show-sizer show-total></Page>
        </div>
      
    </div>
    <detail-modal ref="detail" :data-detail="dataDetail" :is-input="true"  ></detail-modal> 
    <add-repair-modal ref="addRepair" :data-detail="dataDetail" @close-modal="closeModal"  @init="init"></add-repair-modal>
    
    <update-house-modal ref="updateDetail" :data-detail="dataDetail" @close-modal="closeModal" :is-input="false" @init="init" ></update-house-modal> 
    <maintenance-modal ref="maintenanceDetail" :data-detail="dataDetail" @close-modal="closeModal" :is-input="false" @init="init" ></maintenance-modal> 
  </div>
</template>

<script> 
    import {smwxMethod_9_001} from "@/api/9小程序管理/9_001_smwx.js";
    // import detailModal from '@/views/bggl/components/9小程序管理/components/base_detail_modal.vue'
     import detailModal from './components/update_repair_modal/update_repair_modal.vue'
    import addRepairModal from './components/add_repair_modal/add_repair_modal.vue'
     import updateHouseModal from './components/update_repair_modal/update_repair_modal.vue'
    // import updateHouseModal from '../../base_detail_modal/update_house_modal/update_house_modal.vue'
     import maintenanceModal from './components/maintenance_modal/maintenance_modal.vue'
      import topUserV2 from "@/views/components/topUserV2/topUserV2.vue"; 
export default {
  name:"topUser",
   components:{topUserV2,detailModal, addRepairModal,updateHouseModal,maintenanceModal}, 
  created(){
        // this.initializeData()
        // console.log("screenWidth==",screenWidth)
        this.init()
    },
    computed: {
        screenWidth() {
            return this.$screenWidth;
        },
        screenHeight() {
            return this.$screenHeight;
        },
    },
    data() {
        return {
            currentModelName:"房屋维修管理",
            params:{
                fwdz:"",//房屋地址
                wxzt:"",//维修状态
                cjsj:[],//创建时间
                repair_date_start:"",
                repair_date_end:"",
                bxr:"",//报修人
                wxr:"",//维修人 
                gzlx:"",//故障类型
                gzqy:"",//故障区域
                repairType:"",//维修类别【维修，维保】
                maintenanceType:"",//维保类别【'到期','违约','换房','续租'】
            },

            columns:[
                 { type: 'selection',  width: 60,  align: 'center',fixed:"left" },
                // {title: '序号', type: 'index', width: 60, align: 'center'},
                {title: '房屋地址', key: 'houseAddress', width: 300, align: 'center',fixed:"left"},
               
                {title: '维修状态', key: 'repairStatus', width: 200, align: 'center'},
                 {title: '创建人', key: 'create_user', width: 200, align: 'center'},
                {title: '租客姓名', key: '租客姓名', width: 200, align: 'center'},
                {title: '租客联系电话', key: 'repairPersonContact', width: 200, align: 'center'},
                {title: '发起报修时间', key: 'repairTime', width: 250, align: 'center'},
                // {title: '房屋情况描述', key: 'houseDescription', width: 200, align: 'center'},
                {title: '问题数量', key: 'questionCount', width: 150, align: 'center'},
                // {title: '维修工时', key: 'repairHours', width: 200, align: 'center'},
                // {title: '故障类型', key: '故障类型', width: 200, align: 'center'},
                // {title: '故障区域', key: '故障区域', width: 200, align: 'center'},
                // {title: '响应时间', key: 'responseTime', width: 200, align: 'center'},
                // {title: '响应备注', key: 'responseNote', width: 200, align: 'center'},
                
                {title: '操作', slot: 'action', width: 240, align: 'center',fixed:"right"},

            ],
           
            //单独拿出来
            //房屋托管合同信息  产证信息 身份证信息

            pageSetting:{
                pageSize: 15,
                pageIndex: 1,
                total: 0
            },
            dataList:[

            ],
            dataDetail:{
                "房屋地址":"",//房屋地址
                "房源ID":"",//房源ID 
                "故障类型":"",//故障类型
                "故障区域":"",//故障区域
                "上门日期":"",//上门日期
                "上门时间":"",//上门时间
                "故障描述":"",//故障描述
                "联系电话":"",//联系电话
                "附件信息":[],//附件信息

                "租客姓名":"",//联系电话
                "联系电话":"",//联系电话
            },//单个房源详情
            lldList:[],// 
            gsdList:[],// 
            // table选择数据
            selectRowList:[]
           
        }
    },
    
    mounted(){},
    watch:{},
    methods:{
        init(){

            let exampleObj={
                id:"9999",
                "维修单类型":"维保",
                "houseAddress":"宏光路276号大明宏苑6栋2单元401室",
                "repairStatus":"维保单不显示",
                "repairPersonContact":"13388679096",
                "repairTime":"2025-10-30",
                "questionCount":"/",
                "房屋地址":"宏光路276号大明宏苑6栋2单元401室",
                "租客姓名":"印晨亮",
                "报修人联系电话":"13388679096", 
                "维保单类型":"换房",
                "维保_是否保洁":"是",
                "维保_出房人":"小李",
                "维保_出房人反馈时间":"2025-11-06",
                "维保_出房人反馈信息":"楼下没门禁，电池没电",
                "维保_保洁通知日期":"2025-11-07",
                "维保_抽查日期":"2025-11-09",
                "维保_备注":"多检查一下",
                "维保_是否全部完成":"否",
                "维保_保洁费用":"340",
                "维保_其他费用":"100",
                fj:[],
                weiBaoList:[
                    {
                        id:"100",
                        father_id:"9999",
                        type_1:"通知维保",
                        item_name:"检查电路",
                        item_date:"2025-11-09",
                        bz:"",
                        is_complete:"否",
                        result:"",
                        is_del:"0",
                    },
                     {
                        id:"101",
                        father_id:"9999",
                        type_1:"通知维保",
                        item_name:"检查管道，燃气",
                        item_date:"2025-11-010",
                        bz:"",
                        is_complete:"否",
                        result:"",
                        is_del:"0",
                    }
                ],
                 wanChengList:[
                    {
                        id:"103", father_id:"9999", type_1:"完成维保",
                        item_name:"更换5号电池4节",
                        item_date:"2025-11-09",
                        bz:"",  is_complete:"否", result:"", is_del:"0",
                    },
                    {
                        id:"104", father_id:"9999", type_1:"完成维保",
                        item_name:"地漏微堵",
                        item_date:"2025-11-09",
                        bz:"",  is_complete:"否", result:"", is_del:"0",
                    },
                     {
                        id:"105", father_id:"9999", type_1:"完成维保",
                        item_name:"次卧窗帘轻微拉丝",
                        item_date:"2025-11-09",
                        bz:"",  is_complete:"否", result:"", is_del:"0",
                    },
                     {
                        id:"106", father_id:"9999", type_1:"完成维保",
                        item_name:"1.5床垫略脏污",
                        item_date:"2025-11-09",
                        bz:"只换不修",  is_complete:"否", result:"", is_del:"0",
                    },
                     {
                        id:"107", father_id:"9999", type_1:"完成维保",
                        item_name:"窗户下面渗水需要修补",
                        item_date:"2025-11-09",
                        bz:"",  is_complete:"否", result:"", is_del:"0",
                    },
                     {
                        id:"108", father_id:"9999", type_1:"完成维保",
                        item_name:"门锁贴片损坏，缺钥匙，锁体损坏，门边条坏一根",
                        item_date:"2025-11-09",
                        bz:"",  is_complete:"否", result:"", is_del:"0",
                    },
                     {
                        id:"109", father_id:"9999", type_1:"完成维保",
                        item_name:"主卧射灯损坏2个",
                        item_date:"2025-11-10",
                        bz:"",  is_complete:"否", result:"", is_del:"0",
                    },
                     {
                        id:"110", father_id:"9999", type_1:"完成维保",
                        item_name:"纱窗拉丝严重虚拆除",
                        item_date:"2025-11-10",
                        bz:"",  is_complete:"否", result:"", is_del:"0",
                    },
                     {
                        id:"111", father_id:"9999", type_1:"完成维保",
                        item_name:"房门无钥匙，门锁贴片变形",
                        item_date:"2025-11-10",
                        bz:"",  is_complete:"否", result:"", is_del:"0",
                    },
                     {
                        id:"112", father_id:"9999", type_1:"完成维保",
                        item_name:"客厅餐椅脏污4张，餐桌腿坏",
                        item_date:"2025-11-11",
                        bz:"",  is_complete:"否", result:"", is_del:"0",
                    },
                     {
                        id:"113", father_id:"9999", type_1:"完成维保",
                        item_name:"贴脚线和平口条需要打胶",
                        item_date:"2025-11-11",
                        bz:"",  is_complete:"否", result:"", is_del:"0",
                    },
                     
                ],
                repairList:[
                    {
                        id:"203", father_id:"9999", type_1:"供货商维修",
                        item_name:"餐桌椅从大阳沟611搬来更换",
                        item_date:"2025-10-21",
                        bz:"",  is_complete:"是", result:"", is_del:"0",
                    },
                ],
                projectList:[
                    {
                        id:"303", father_id:"9999", type_1:"工程业务协助",
                        item_name:"协助更换瓷砖",
                        item_date:"2025-11-01",
                        bz:"40*40",  is_complete:"是", result:"", is_del:"0",
                    },
                ],  
            }
            console.log("父级666")
            console.log("params===",this.params)
            let params=this.params
            params.pageSize=this.pageSetting.pageSize
            params.pageIndex=this.pageSetting.pageIndex
            params.version="2", 
            smwxMethod_9_001.selectWxList(params).then((res)=>{
                console.log("res===",res)
                res.data.list.forEach((i)=>{
                    i.questionCount=i.childList?i.childList.length:0
                })
                this.$nextTick(()=>{
                    this.dataList=res.data.list
                    this.dataList.push(exampleObj)
                    this.pageSetting.total=res.data.total 
                    console.log("this.dataList==",this.dataList)
                    // this.watchDetail({id:"60a23c03e4b0bcb167f69b2e:60f685a3e4b0ce8c613253fc"})
                })
                

            })
        },
        // 响应维修
        operateResponse(row){
            let params={
                id:row.id
            }
            smwxMethod_9_001.getById(params).then((res)=>{
                console.log("detail==res===",res)
                this.dataDetail=res.data.smwxInfo 
                console.log("this.dataDetail==",this.dataDetail)
             
               this.$refs.response.responseModal=true
                // this.$nextTick(()=>{
                //     this.$refs.detail.detailModal=true
                // })

            }) 
        },
        // 查看详情
        watchDetail(row){
             this.dataDetail=row 
             console.log("父级this.dataDetail==",this.dataDetail)
             this.$refs.detail.detail_modal=true

              this.$nextTick(()=>{
                 this.$refs.detail.cleanData()
                  this.$refs.detail.initQuestionList()
              })
            
   
        },
        // 修改
        updateDetail(row){
            this.dataDetail=row 
             console.log("父级this.dataDetail==",this.dataDetail)
             if(row['维修单类型']=="维保"){
                this.$refs.maintenanceDetail.detail_modal=true
                 this.$nextTick(()=>{
                    this.$refs.maintenanceDetail.cleanData()
                    this.$refs.maintenanceDetail.initWeiBaoList()
                })
             }else{
                this.$refs.updateDetail.detail_modal=true
                this.$nextTick(()=>{
                    this.$refs.updateDetail.cleanData()
                    this.$refs.updateDetail.initQuestionList()
                })

             }
            
        },
        // 填写维修情况
        writeRepairCondition(row){
            let params={
                id:row.id
            }
            smwxMethod_9_001.getById(params).then((res)=>{
                console.log("detail==res===",res)
                this.dataDetail=res.data.smwxInfo 
             
                this.lldList=res.data.lldList 
                this.gsdList=res.data.gsdList 
               
         
                this.$refs.repair.updateModal=true
                // this.$nextTick(()=>{
                //     this.$refs.detail.detailModal=true
                // })

            })
        },
          // 修改非附件信息
          updateInfo(row){
            let params={
                id:row.id
            }
            smwxMethod_9_001.getByIdforUpdate(params).then((res)=>{
            
                this.dataDetail=res.data 
                // console.log("dataDetail===",this.)
                this.$refs.updateHouse.updateModal=true
               
            })
        },
        // 逻辑删除
        deleteRecord(row){
            let _this=this
            this.$Modal.confirm({
              title: '确认删除提醒',
              content: `<br>请注意，点击确认后不可撤回<br>`,
              onOk(){
                let param={id:row.id}
               
                smwxMethod_9_001.deleteRecord(param).then((res)=>{
                  console.log("删除——res====",res)
                  if(res.data.deleteRes!=0 && res.data.deleteRes!=null){
                    _this.$Message.success("删除成功！")
                    _this.init()
                    _this.updateModal=false
               
                  }
                })


              }})
       
        },
        // 其他业务
        otherOperate(row){
            let params={
                id:row.id
            }
            smwxMethod_9_001.getById(params).then((res)=>{
                console.log("detail==res===",res)
                this.dataDetail=res.data 
                this.$nextTick(()=>{
                    this.$refs.otherOperate.otherModal=true
                    this.$refs.otherOperate.changeIllustrate("修改附件")
                })

            })
         
        },
        // 新增
        add(){
            this.dataDetail={
                "房屋地址":"",//房屋地址
                "房源ID":"",//房源ID 
                "故障类型":"",//故障类型
                "故障区域":"",//故障区域
                "上门日期":"",//上门日期
                "上门时间":"",//上门时间
                "故障描述":"",//故障描述
                "联系电话":"",//联系电话
                "附件信息":[],//附件信息

                "租客姓名":"",//联系电话
                "联系电话":"",//联系电话
            }
            this.$refs.addRepair.add_repair_modal=true
        },
        clear(){
            this.params={
                fwdz:"",//房屋地址
                sfr:"",//收房人
                sfmd:"",//收房门店
                ywzt:"",//业务状态
                htqzsj:null,//合同起止时间
                htStart:"",htEnd:"",//拆分为start和end时间
                pageSize:15,
                pageIndex:1,
            }
            this.init()
        },
        addMaintenance(){
               this.dataDetail={
                "房屋地址":"",//房屋地址
                "房源ID":"",//房源ID 
                "故障类型":"",//故障类型
                "故障区域":"",//故障区域
                "上门日期":"",//上门日期
                "上门时间":"",//上门时间
                "故障描述":"",//故障描述
                "联系电话":"",//联系电话
                "附件信息":[],//附件信息

                "租客姓名":"",//联系电话
                "联系电话":"",//联系电话
            }
            this.$refs.maintenanceDetail.detail_modal=true

        },
        closeModal(){
            let dataDetail={
             "房屋地址":"",//房屋地址
                "房源ID":"",//房源ID 
                "故障类型":"",//故障类型
                "故障区域":"",//故障区域
                "上门日期":"",//上门日期
                "上门时间":"",//上门时间
                "故障描述":"",//故障描述
                "联系电话":"",//联系电话
                "附件信息":[],//附件信息 
                "租客姓名":"",//联系电话
                "联系电话":"",//联系电话
          }
          this.dataDetail=dataDetail
          this.init()
        },
        pageSizeChange(i) {
            this.pageSetting.pageSize = i;
            this.init()
        },
        pageChange(i) {
            this.pageSetting.pageIndex = i;
            this.init()
        },
        changeDate(date){
            // console.log("date==",date)
            this.params.htStart=date[0]
            this.params.htEnd=date[1]
        },
        formatTimestamp(timestamp) {
            const date = new Date(timestamp);
            console.log("date==",date)

            // 获取年月日时分秒
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            // 拼接成 "YYYY-MM-DD HH:mm:ss" 格式
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
           changeCjsjDate(date){
            console.log("date==",date)
            this.params.repair_date_start=date[0]
            this.params.repair_date_end=date[1]
            this.init()
        },
        // table选择改变事件
        tableChange(list){
            console.log("select-list===",list)
             this.selectRowList=list
        },
        // exportFile导出
        exportFile(){

        },
    }


}
</script>

  
  <style lang="scss" >
@import '9_001_smwx.scss'; 

  </style>